export const getLeadsPage = (data) => {
    if (!data || typeof data !== "object") return {};
    return data.leads ?? data;
};

export default getLeadsPage;